module.exports = __webpack_public_path__ + "media/en-pc-banner-video.6e396043.mp4";